export default "__VITE_ASSET__CCWMB3pw__"